import {Breadcrumb, Button, Space, Popconfirm, message, Form, Modal, Input, Select, Spin} from "antd"
import {useState, useRef, useContext, useEffect} from "react";
import {Link} from "react-router-dom"
import {DashboardOutlined, DeleteOutlined, EditOutlined, PlusSquareOutlined} from "@ant-design/icons"
import {BsPencilSquare} from "react-icons/bs";
import DataTable from "../../components/common/table";
import UploadButton from "../../components/common/uploadButton";
import Header from "../../components/dashboard/header";
import {useCreateUnit, useDeleteUnit, useGetAllUnits, useUpdateUnit} from "../../hooks/unit/unitQuery";
import {useDepartments,} from "../../hooks/department/departmentQuery";
import {extractValueFromInputRef, scrollToTop} from "../../helpers/dom";
import RefreshContext from "../../context/refreshContext";


const {Option} = Select;


const unitTableColumns = [
    {
        title: "S/N",
        key: "s/n",
        render: (_, __, idx) => idx + 1
    },
    {
        title: "Name",
        dataIndex: "title",
        key: "name"
    },
    {
        title: "Code",
        dataIndex: "value",
        key: "name"
    },
    {
        title: "Department",
        render: (_, unit) => unit.department.title,
        key: "department"
    },
    {
        title: "Actions",
        key: "actions",
        render: (_, unit) => (
            <UnitEdit unit={unit}/>
        )
    }
]


function UnitEdit({unit}) {
    const [dep, setDep] = useState(unit.department.id)
    const [isEditOpen, setIsEditOpen] = useState(false);
    const showEditModal = () => setIsEditOpen(true);
    const hideEditModal = () => setIsEditOpen(false);

    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const officeTitleRef = useRef(null);

    const updateUnit = useUpdateUnit();
    const deleteUnit = useDeleteUnit()

    const {flag, setFlag} = useContext(RefreshContext);

    const {departments} = useDepartments(flag);

    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            department: dep,
            officeTitle: extractValueFromInputRef(officeTitleRef)
        }
        const {message: response} = await updateUnit(unit.id, payload);
        message.success(response ?? "unit updated successfully");
        setIsEditOpen(false);
        setFlag(!flag);
    }

    const confirmDeleteDepartment = async () => {
        const {message: response} = await deleteUnit(unit.id);
        message.success(response ?? "unit deleted successfully");
        setFlag(!flag);
    };


    return (
        <>
            <Space size="small" wrap>
                <Button type="primary" onClick={showEditModal}>
                    <EditOutlined/>
                    Edit
                </Button>
                <Popconfirm
                    title="Delete this unit"
                    description="Are you sure to delete this unit?"
                    onConfirm={confirmDeleteDepartment}
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="primary" danger>
                        <DeleteOutlined/>
                        Delete
                    </Button>
                </Popconfirm>
            </Space>
            <Modal title="Update Unit" open={isEditOpen} footer={null} onCancel={hideEditModal}>
                <div style={{marginTop: "3em"}}>
                    <Form
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            ...unit
                        }}>
                        <Form.Item
                            name="title"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input title!',
                                },
                            ]}>
                            <Input size="large" ref={titleRef} placeholder="Title"/>
                        </Form.Item>
                        <Form.Item
                            name="value"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input name of unit!',
                                },
                            ]}>
                            <Input size="large" ref={valueRef} placeholder="Code"/>
                        </Form.Item>
                        <Form.Item
                            name="officeTitle"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input office title!',
                                },
                            ]}>
                            <Input size="large" ref={officeTitleRef} placeholder="Office title"/>
                        </Form.Item>
                        <Form.Item
                            name="department"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Select
                                placeholder="Select a Department"
                                onChange={(e) => setDep(e)}
                            >
                                {
                                    departments.map((d, idx) => (
                                        <Option key={idx} value={d.id}>{d.title}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 8,
                                offset: 18
                            }}
                            className="submit-button-wrapper"
                        >
                            <Button style={{backgroundColor: "green"}} size="large" type="primary" htmlType="submit"
                                    onClick={handleSubmit}>
                                Update Unit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}


export default function Unit() {
    const [isOpen, setIsOpen] = useState(false);
    const [dep, setDep] = useState("");

    const showCreateModal = () => setIsOpen(true);
    const hideCreateModal = () => setIsOpen(false);

    const titleRef = useRef(null);
    const valueRef = useRef(null);
    const officeTitleRef = useRef(null);

    const {flag, setFlag} = useContext(RefreshContext);

    const {units, loading} = useGetAllUnits(flag);
    const {departments} = useDepartments(flag);
    const createUnit = useCreateUnit();


    useEffect(() => {
        scrollToTop();
    }, []);


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            value: extractValueFromInputRef(valueRef),
            department: dep,
            officeTitle: extractValueFromInputRef(officeTitleRef)
        }
        const {message: response} = await createUnit(payload);
        message.success(response ?? "unit created successfully");
        setIsOpen(false);
        setFlag(!flag);
    }

    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Office</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <BsPencilSquare/>
                                <Link to="/dashboard/user">Unit</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display: 'flex', gap: '1em'}}>
                            <UploadButton/>
                            <Button style={{backgroundColor: "green", color: "#FFFFFF"}} onClick={showCreateModal}>
                                <PlusSquareOutlined/>
                                Add Unit
                            </Button>
                        </div>
                    </div>

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable cols={unitTableColumns} data={units}/>
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal title="Add Unit" open={isOpen} footer={null} onCancel={hideCreateModal}>
                <div style={{marginTop: "3em"}}>
                    <Form
                        wrapperCol={{
                            span: 24,
                        }}>
                        <Form.Item
                            name="title"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input title!',
                                },
                            ]}>
                            <Input size="large" placeholder="Title" ref={titleRef}/>
                        </Form.Item>
                        <Form.Item
                            name="unit"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input name of unit!',
                                },
                            ]}>
                            <Input size="large" placeholder="Code" ref={valueRef}/>
                        </Form.Item>
                        <Form.Item
                            name="officeTitle"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input office title!',
                                },
                            ]}>
                            <Input size="large" ref={officeTitleRef} placeholder="Office title"/>
                        </Form.Item>
                        <Form.Item
                            name="department"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Select
                                placeholder="Select a Department"
                                onChange={(e) => setDep(e)}
                            >
                                {
                                    departments.map((d, idx) => (
                                        <Option key={idx} value={d.id}>{d.title}</Option>
                                    ))
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 8,
                                offset: 18
                            }}
                            className="submit-button-wrapper"
                        >
                            <Button style={{backgroundColor: "green"}} size="large" type="primary" htmlType="submit"
                                    onClick={handleSubmit}>
                                Add Unit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
